import { Component, computed, effect, inject, input } from '@angular/core';
import { CoreJssProxyModule, TextField } from '@core/jss-proxy';
import { JssPlatformService } from '@core/jss-platform';
import { FieldService } from '@core/jss-utils';
import { ContentSectionService } from '@core/content-section';
import { NgClass } from '@angular/common';
import type { InnogyComponentRendering } from '@core/jss-models';

@Component({
  selector: 'wl-text-widget',
  standalone: true,
  imports: [CoreJssProxyModule, NgClass],
  templateUrl: './text-widget.component.html',
  styleUrls: [
    './text-widget.component.ed.scss',
    './text-widget.component.essent.scss',
  ],
})
export class TextWidgetComponent {
  readonly #fieldService = inject(FieldService);
  readonly #jssPlatformService = inject(JssPlatformService);

  readonly contentSectionService = inject(ContentSectionService);

  readonly inverse = input<boolean>(false);

  readonly title = input.required<TextField>();
  readonly content = input.required<TextField>();
  readonly widget = input.required<InnogyComponentRendering>();

  theme = 'Wit';

  constructor() {
    effect(() => {
      this.theme = this.contentSectionService?.theme() ?? 'Wit';
    });
  }

  readonly showContent = computed(() =>
    this.#fieldService.showTextField(this.content())
  );

  readonly isEditorActive = computed(() =>
    this.#jssPlatformService.isEditorActive()
  );
}
